import {
  ROUTE_TYPE_CONFIG,
  ROUTE_TYPE_UNCLASSIFIED,
  ROUTE_TREE_BRANCH_DIRECTION,
  ROUTE_TREE_COORDINATES,
} from './RouteTree.constants';
import { ROTATIONS } from '../../utils/constants/charting';
import { VISUALISATION_FONT_SETUPS } from '../../utils/constants/visText';
import { fontVerticalCenterY } from '../text';

export const getTreeBranches = (routeSummary, visPalette) => {
  /* For branches, do not draw link to unclassified */
  const classifiedCoordinates = ROUTE_TREE_COORDINATES.filter(
    (c) => c.routeType !== ROUTE_TYPE_UNCLASSIFIED.apiKey,
  );
  const branchData = classifiedCoordinates.map((branch) => {
    const branchValues = routeSummary[branch.routeType].branch;
    const { strokeWidth } = branchValues;
    const { strokeDash } = branchValues;
    /* A dashed branch is a route nobody ran, so it is drawn as unused */
    const stroke = strokeDash
      ? visPalette.unusedObject
      : visPalette.selectedObject;

    const branchInfo = {
      ...branch,
      stroke,
      strokeWidth,
      strokeDash,
    };
    return branchInfo;
  });
  return branchData;
};

export const getTreeFruit = (routeSummary, visPalette, isDarkMode) => {
  const fruitData = ROUTE_TREE_COORDINATES.map((branch) => {
    const fruitValues = routeSummary[branch.routeType].fruit;
    const stroke = visPalette.selectedObject;
    const strokeWidth = 1;
    const fill = fruitValues.fillFunction(fruitValues.fillValue, isDarkMode);

    const fruitInfo = {
      ...branch,
      stroke,
      strokeWidth,
      fill,
      opacity: 1, // when we add selection mode this will become variable
    };
    return fruitInfo;
  });
  return fruitData;
};

const getTextRotation = (orientation) => {
  if (orientation === ROTATIONS.VERTICAL_UP) {
    return 'rotate(90)';
  }
  if (orientation === ROTATIONS.VERTICAL_DOWN) {
    return 'rotate(-90)';
  }
  return 'rotate(0)';
};
const getTextAnchor = (inOut) => {
  if (inOut === ROUTE_TREE_BRANCH_DIRECTION.UP) {
    return 'middle';
  }
  if (inOut === ROUTE_TREE_BRANCH_DIRECTION.IN) {
    return 'start';
  }
  return 'end';
};

const labelSize = VISUALISATION_FONT_SETUPS.AXES_LABELS.SIZE;
const centerLabel = fontVerticalCenterY(labelSize);
const getTextBaseline = (routeTypeKey, orientation) => {
  /* Go label is special */
  if (routeTypeKey === ROUTE_TYPE_CONFIG.go.apiKey) {
    if (orientation === ROTATIONS.HORIZONTAL) {
      return centerLabel;
    }
    if (orientation === ROTATIONS.VERTICAL_UP) {
      return 0;
    }
    return labelSize;
  }
  /* Other labels */
  if (orientation === ROTATIONS.VERTICAL_UP) {
    return centerLabel;
  }
  if (orientation === ROTATIONS.VERTICAL_DOWN) {
    return -centerLabel;
  }
  return 0;
};

export const getTreeLabels = (visPalette, orientation, routesSummary) => {
  const labelData = ROUTE_TREE_COORDINATES.map((branch) => {
    const config = ROUTE_TYPE_CONFIG[branch.routeType];
    const values = routesSummary[branch.routeType];

    const labelInfo = {
      ...branch,
      name: config.name,
      fill: visPalette.text.subHeader,
      rotation: getTextRotation(orientation),
      anchor: getTextAnchor(config.direction),
      y: getTextBaseline(config.apiKey, orientation),
      tooltip: values.tooltip,
    };
    return labelInfo;
  });
  return labelData;
};
